import { render, staticRenderFns } from "./DeveloperSettings.vue?vue&type=template&id=30caba10&scoped=true"
import script from "./DeveloperSettings.vue?vue&type=script&lang=js"
export * from "./DeveloperSettings.vue?vue&type=script&lang=js"
import style0 from "./DeveloperSettings.vue?vue&type=style&index=0&id=30caba10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30caba10",
  null
  
)

export default component.exports